'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hourBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/hourBefore.js
// module id = 678
// module chunks = 0